import NavElement from './navElement';
import { useUser } from "../../context/UserContext";
import { useNavigate, Link } from 'react-router-dom';

const UserSection = () => {
    const { user, setUser } = useUser();
    const navigate = useNavigate();
    const auth = !!user;
    const isHostUser = auth && user?.role === 'host';

    const signout = () => {
        setUser(null);
        localStorage.removeItem('user');
        navigate('/');
    };

    return auth ? 
    <div className="nav-user-section">
        <Link to="/profile" className="nav-user-greeting nav-user-greeting-link">Hello {user.display}</Link>
        {isHostUser && (
            <Link to="/direct-booking-dashboard" className="nav-element nav-link">Direct Bookings</Link>
        )}
        <button type="button" className="nav-signout-btn nav-element nav-link" onClick={signout}>Log Out</button>
    </div>
    : 
    <div className="nav-auth-links">
        <NavElement title={"Login"} />
        <NavElement title={"Sign Up"} path="signup" />
    </div>;
};

export default UserSection;